var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// TODO this whole file needs to be broken down or removed
import EventBus from '@EventBus';
import { APP_STORE, MENU_ITEMS, MENU_OPTIONS, MENU_OPTION_EXCEPTIONS, ACCOUNT, CATEGORY, RECENT_ORDERS, LOCATION, CART, ACCOUNT_CHECKOUT, FRANCHISOR } from '@/stores/defs';
import Vue from 'vue';
import store from '@/stores/index';
import { mapActions, mapGetters } from 'vuex';
import allService from '@/services/all.service';
import categoryService from '@/services/category.service';
import optionService from '@/services/option.service';
import customerService from '@/services/customer.service';
import guestService from '@/services/guest.service';
import locationService from '@/services/location.service';
import Promise from 'ts-promise';
var InitialOrderSetup = function (resolve) {
    // @ts-ignore
    require.ensure([], function () {
        resolve(require('@/components/orders/initial-order-setup/InitialOrderSetup'));
    });
};
var StoreLocator = function (resolve) {
    // @ts-ignore
    require.ensure([], function () {
        resolve(require('@/components/store-locator/StoreLocator/StoreLocator'));
    });
};
import { ERROR_MSG } from '@/common/messages/error.msg';
import Analytics from '@Analytics';
import { LOCATION_ANALYTIC_EVENT } from '@/common/analytic-events/locationAnalyticEvent';
import * as VueGoogleMaps from 'vue2-google-maps';
import { findNextAvailableTime } from '@/utils/helper.functions';
import { findIndex, remove, merge } from 'lodash';
// Mixins
import modalMixin from '@/components/mixins/modalMixin';
import flowStateMixin from '@/components/mixins/flowStateMixin';
import trackerMixin from '@Mixin/trackerMixin';
import navigationMixin from '@Mixin/navigationMixin';
import timeMixin from '@Mixin/timeMixin';
// Models
import OrderModel from '@Model/OrderModel';
import couponMixin from '@Mixin/couponMixin';
import { couponService } from '@Service/coupon.service';
var localforage = require('localforage');
var storeLoaderMixin = {
    mixins: [
        modalMixin,
        timeMixin,
        flowStateMixin,
        trackerMixin,
        navigationMixin,
        couponMixin
    ],
    computed: __assign({}, mapGetters({
        customer: ACCOUNT.GET_CUSTOMER,
        guestAddress: ACCOUNT.GET_GUEST_ADDRESS,
        userSetServiceType: ACCOUNT_CHECKOUT.GET_USER_SET_SERVICE_TYPE,
        appIsLoaded: APP_STORE.LOADED,
        hasMenuItems: MENU_ITEMS.HAS_ITEMS,
        currentLocation: LOCATION.GET_LOCATION,
        recentOrders: RECENT_ORDERS.GET_RECENT_ORDERS,
        orderTime: ACCOUNT_CHECKOUT.GET_ORDER_TIME,
        cartItemCount: CART.ITEM_COUNT,
        currentGmapAPIKey: APP_STORE.GET_GMAP_API,
    })),
    methods: __assign({}, mapActions({
        setCategories: CATEGORY.SET_ALL,
        setItems: MENU_ITEMS.SET_ALL,
        setOptions: MENU_OPTIONS.SET_ALL,
        setOptionExceptions: MENU_OPTION_EXCEPTIONS.SET_ALL,
        setCustomer: ACCOUNT.SET_CUSTOMER,
        setActiveOrder: RECENT_ORDERS.SET_ACTIVE_ORDER,
        setRecentOrders: RECENT_ORDERS.SET_RECENT_ORDERS,
        setLocation: LOCATION.SET_LOCATION,
        setLoggedIn: ACCOUNT.SET_LOGGED_IN,
        setCart: CART.SET_ITEMS,
        clearCart: CART.CLEAR_CART,
        setOrderTime: ACCOUNT_CHECKOUT.SET_ORDER_TIME,
        setLoaded: APP_STORE.SET_LOADED,
        setOffers: ACCOUNT.SET_OFFERS,
        setFranchisor: FRANCHISOR.SET_FRANCHISOR,
        setMenuId: MENU_ITEMS.SET_MENU_ID,
        setGmapAPIKey: APP_STORE.SET_GMAP_API,
        setStoreDeepLink: APP_STORE.SET_STORE_DEEP_LINK,
    }), { storeCategories: function (categories) {
            categoryService.setCategoriesForStorage(categories);
        },
        categoriesLoader: function () {
            var categories = categoryService.getCategoriesFromStorage();
            if (categories) {
                this.setCategories(categories);
            }
        },
        storeOptions: function (options) {
            optionService.setOptionsForStorage(options);
        },
        optionsLoader: function () {
            var options = optionService.getOptionsFromStorage();
            if (options) {
                this.setOptions(options);
            }
        },
        storeOptionExceptions: function (optionExceptions) {
            optionService.setOptionExceptionsForStorage(optionExceptions);
        },
        optionExceptionsLoader: function () {
            var optionExceptions = optionService.getOptionExceptionsFromStorage();
            if (optionExceptions) {
                this.setOptionExceptions(optionExceptions);
            }
        },
        customerLoader: function () {
            var customer = store.getters[ACCOUNT.GET_CUSTOMER];
            if (!customer) {
                customer = customerService.getCustomerFromStorage();
            }
            if (customer) {
                this.setCustomer(customer);
            }
        },
        storeCustomer: function (customer) {
            customerService.setCustomerForStorage(customer);
        },
        locationLoader: function () {
            var location = locationService.getLocationFromStorage();
            if (location) {
                this.setLocation(location);
            }
        },
        couponLoader: function () {
            var coupon = couponService.getCouponFromStorage();
            if (coupon) {
                this.useCoupon(coupon.codeName, true, coupon);
            }
        },
        storeLocation: function (location) {
            locationService.setLocationForStorage(location);
        },
        loadAllFromStorage: function () {
            var _this = this;
            new Promise(function (resolve) {
                _this.categoriesLoader();
                resolve(true);
            }).then(function () {
                _this.optionsLoader();
            }).then(function () {
                _this.optionExceptionsLoader();
            }).then(function () {
                _this.customerLoader();
            }).then(function () {
                _this.locationLoader();
            }).then(function () {
                _this.couponLoader();
            });
        },
        loadAll: function (lb, forceLoad) {
            var _this = this;
            if (lb === void 0) { lb = null; }
            if (forceLoad === void 0) { forceLoad = true; }
            return new Promise(function (resolve) {
                allService.load(function (_a, errObj) {
                    var menu = _a.menu, customer = _a.customer, offers = _a.offers, recentOrders = _a.recentOrders, location = _a.location, activeOrder = _a.activeOrder, franchisor = _a.franchisor, apiKey = _a.apiKey;
                    if (_this.appIsLoaded && !forceLoad) {
                        return;
                    }
                    if (errObj && errObj.msg === ERROR_MSG.APP.ONLINE_ORDERING_DISABLED) {
                        // franchisor loaded for google maps
                        var franchisor_1 = errObj.franchisor;
                        if (franchisor_1) {
                            _this.setFranchisor(franchisor_1);
                            var mapsAPIKey = franchisor_1.getGoogleMapsAPIKey();
                            _this.setGmapAPIKey(apiKey);
                            if (mapsAPIKey) {
                                _this.loadGoogleMaps(mapsAPIKey);
                                console.error('online ordering was disabled from this location: loading franchisor key');
                            }
                        }
                        _this.triggerModal({
                            component: StoreLocator,
                            showCloseButton: false,
                            classes: 'global-modal',
                            title: 'Locations'
                        });
                    }
                    else {
                        if (menu) {
                            _this.setCategories(menu.categories);
                            _this.setItems(menu.items);
                            EventBus.$emit('store-loaded');
                            _this.setOptions(menu.options);
                            _this.setOptionExceptions(menu.optionExceptions);
                            _this.setMenuId(menu.menuId);
                        }
                        // TODO move this into service, service should be the only object to communicate with store and storage
                        var customerStore = store.getters[ACCOUNT.GET_CUSTOMER];
                        if (customerStore && !customer.id) {
                            _this.setCustomer(customerStore);
                        }
                        else {
                            _this.setCustomer(customer);
                        }
                        if (activeOrder) {
                            var orderCustomer = { customer: customer };
                            var mergedOrder = merge(activeOrder, orderCustomer);
                            var order = new OrderModel(mergedOrder);
                            if (order.isValidOrder()) {
                                _this.setTrackerActive(true);
                                _this.setTrackerPosition(order.trackerStatus - 1); //hack to set previous position
                                _this.setTrackerPosition(order.trackerStatus);
                            }
                            _this.setActiveOrder(activeOrder);
                        }
                        _this.setOffers(offers);
                        if (location) {
                            _this.setLocation(location);
                            _this.setStoreDeepLink(true);
                        }
                        _this.setFranchisor(franchisor);
                        if (!location) {
                            _this.triggerInitialOrderModal();
                        }
                        _this.setRecentOrders(recentOrders);
                        if (menu) {
                            _this.storeCategories(menu.categories);
                            _this.storeOptions(menu.options);
                            _this.storeOptionExceptions(menu.optionExceptions);
                        }
                        _this.setLoaded(true);
                        _this.setGmapAPIKey(apiKey);
                        if (apiKey) {
                            _this.loadGoogleMaps(apiKey);
                        }
                        if (!_this.orderTime && location) {
                            var nextAvailableTime = findNextAvailableTime(location);
                            if (nextAvailableTime) {
                                _this.setOrderTime(nextAvailableTime);
                            }
                        }
                        // set title of homepage
                        document.title = _this.$appConstants.storeName;
                        return resolve(true);
                    }
                }, lb);
            });
        },
        now: function () {
            return Math.floor((new Date()).getTime() / 1000);
        },
        triggerInitialOrderModal: function () {
            var hasLocation = !!(this.currentLocation && this.currentLocation.id);
            var hasCartItems = (this.cartItemCount > 0);
            //router not loaded
            var atCheckout = (document.location.pathname === '/checkout' && hasLocation);
            var atOrderConfirmation = (document.location.pathname === '/order/order-confirmation' && hasLocation);
            if (atCheckout || atOrderConfirmation || hasCartItems) {
                return;
            }
            // Yes, this is a bit of a gross hack but it prevents the code from
            // launching a ton of overlapping modals. I've tried to track down what causes this
            // and it's triggered by being logged in but not having a location selected
            // I was unable to find the root cause of the loop.
            // @ts-ignore
            if (!('lastLaunchedInitial' in window) || window.lastLaunchedInitial < (this.now() - 10)) {
                // @ts-ignore
                window.lastLaunchedInitial = this.now();
                this.triggerModal({
                    component: InitialOrderSetup,
                    showCloseButton: hasLocation,
                    classes: 'global-modal',
                    showHeader: hasLocation
                });
            }
        },
        loadNewStore: function (storeDetails) {
            var _this = this;
            if (storeDetails === void 0) { storeDetails = { locationId: '', hideInitialModal: true }; }
            var closeInitialModal = function () {
                // emit analytics event before closing
                Analytics.$emit('analytics-event', {
                    eventCategory: LOCATION_ANALYTIC_EVENT.category,
                    eventAction: LOCATION_ANALYTIC_EVENT.actions.changed,
                    label: LOCATION_ANALYTIC_EVENT.label.location
                });
                _this.$modal.hide('contentModal');
                var routeName = _this.$router.history.current.name;
                if (routeName === 'item-detail') {
                    var route = _this.$router.currentRoute;
                    _this.$router.push({
                        path: route.path,
                        params: route.params,
                    });
                    window.location.reload();
                    return;
                }
                if (_this._hasCompletedRoute) {
                    _this._navigateToCompletedRoute();
                    return;
                }
                _this._navigateToHome();
            };
            // If we are going to load a new store then we need to clear the cart
            // This is triggered if you change the store via the store selector
            // If you instead open a link to a different store then it's handled in StoreDeepLink
            this.clearCart();
            var showRemovedItemsDialog = function (removedItems) {
                var template = '<p>The following items were not configurable for this store and have been removed from your cart</p><ul class="store-navigation-color">';
                removedItems.forEach(function (item) {
                    template += "<li>" + item.name + "</li>";
                });
                template += '</ul>';
                _this.$modal.show('dialog', {
                    title: 'Cart Update',
                    text: template,
                    buttons: [
                        {
                            title: 'Close',
                            handler: function () {
                                if (storeDetails.hideInitialModal) {
                                    closeInitialModal();
                                }
                                _this.$modal.hide('dialog');
                            }
                        }
                    ]
                });
            };
            // load store
            this.loadAll(storeDetails.locationId, true)
                .then(function (res) {
                if (storeDetails.hideInitialModal) {
                    closeInitialModal();
                }
            }).catch(function (err) {
                console.error(err);
                if (storeDetails.hideInitialModal) {
                    closeInitialModal();
                }
            });
        },
        loadGoogleMaps: function (apiKey) {
            //@ts-ignore
            var googleMapIndex = findIndex(Vue._installedPlugins, function (plugin) {
                var gmapAPI = plugin.gmapApi;
                return (!!gmapAPI);
            });
            if (apiKey === this.currentGmapAPIKey && googleMapIndex !== -1) {
                return;
            }
            // Remove installed plugin
            if (googleMapIndex !== -1) {
                //@ts-ignore
                remove(Vue._installedPlugins, function (plugin, index) {
                    return index === googleMapIndex;
                });
            }
            this.setGmapAPIKey(apiKey);
            Vue.use(VueGoogleMaps, {
                load: {
                    key: apiKey,
                    libraries: 'places,geometry',
                }
            });
        } }),
    watch: {
        customer: {
            handler: function (currentCustomer, oldCustomer) {
                // if modal isn't already active
                if (!this.$refs['initial-order-setup'] && !this.userSetServiceType) {
                    // current customer
                    if (currentCustomer && currentCustomer.id && !this.currentLocation.id) {
                        this.triggerInitialOrderModal();
                    }
                    else if (currentCustomer && !currentCustomer.id && !this.guestAddress) {
                        // guest
                        this.triggerInitialOrderModal();
                        if (this.$route.name === 'payment-response') {
                            return;
                        }
                        guestService.releaseGuestCustomer({
                            base: this.currentLocation.id,
                            customerId: null,
                        }, function (response) { });
                    }
                }
            }
        }
    },
    created: function () {
        localforage.config({
            driver: [
                localforage.INDEXEDDB,
                localforage.LOCALSTORAGE
            ],
            name: 'tp-online-store'
        });
    },
};
export default storeLoaderMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/storeLoaderMixin.ts
// module id = null
// module chunks = 